<script lang="ts">
	import type { PageContent } from "$lib/def/seo/page";

	import { createTextEditorAction } from '$lib/serv/admin/edit';
	import { createImageEditorAction } from "$lib/serv/admin/editImg";
	import { imgSrc, imgSrcSet } from "$lib/serv/image-details";
	import { geoOpted$, setGeoOpted } from "$lib/serv/locations";
	import { editable$, editing$ } from "$lib/serv/seo";
	import { selectAddress } from '$lib/ui/modals/AddressModal.svelte';
	
	import Editor from "../cms/Editor.svelte";
	import BaseBlock from "../cms/blocks/BaseBlock.svelte";
	import BaseLink from "../cms/blocks/BaseLink.svelte";
	import Standard from "../cms/blocks/Standard.svelte";
	import LazyImage from "../shared/LazyImage.svelte";

	export let content: PageContent;

	let length = Object.keys(content)
	.filter(key => key.includes('block-'))
	.map(key => key.split('-')[1])
	.map(n => +(n||0))
	.reduce((acc, current) => Math.max(acc, current), 0);


	async function currentLocation() {
		setGeoOpted();
		selectAddress();
	}

	function getBaseComponent(content: PageContent, i: number | string) {
		const type = content[`block-${i}-type`] || '';
		if (type === 'hidden') return;
		const href = content[`block-${i}-href`];
		if (typeof href === 'string') return 'link';
		return 'block';
	}

	let editImage: Editor['editImage'];
	let editString: Editor['editString'];
	
	const editText = createTextEditorAction('page', content.slug);
	const editImg = createImageEditorAction('page', content.slug);
</script>

{#if $editable$}
	<Editor bind:editImage bind:editString />
{/if}

<div class="home_vertical_header">
	<div>
		{#if $editing$}
			<img use:editImg={[`image`, '600x0', current => editImage?.(current)]} src={imgSrc(content.image, '600x0')} alt={content.slug}>
		{:else}
			<LazyImage {...imgSrcSet(content.image, 0.5)} alt={content.slug} />
		{/if}
	</div>
	<section>
		<section>
			<h2 class="display-m bold" use:editText={['title']}>{content.title}</h2>
			<p class="body-m" use:editText={['description']}>{content.description}</p>
		</section>
		<article>
			<button class="button label-xl" on:click={() => selectAddress()}>&nbsp;<span class="icon-pin-outline-20">&nbsp;</span>Enter address</button>
			<!-- TODO: find out if this can be changed - this feature is available when you click the enter address button -->
			{#if !$geoOpted$}
				<button class="book-s medium" on:click={(e) => currentLocation()}>&nbsp;<span class="icon-current-location-20">&nbsp;</span>Use current location</button>
			{/if}
		</article>
	</section>
</div>

<div class="home_vertical_body relative">
	{#each {length} as _, index}
		{@const type = getBaseComponent(content, index)}
		{#if type === 'block'}
			<BaseBlock {content} {index}>
				<Standard {content} {index} {editImage} />
			</BaseBlock>
		{:else if type === 'link'}
			<BaseLink {content} {index} editHref={editString}>
				<Standard {content} {index} {editImage} />
			</BaseLink>
		{/if}
	{/each}
	{#if $editing$}
		<div class="add">
			<!-- <button class="button secondary small" on:click={() => addBlock(true)}>Remove block</button> -->
			<button class="button secondary small" on:click={() => length++}>Add block</button>
		</div>
	{/if}
</div>

<div class="home_vertical_footer">
	<h2 use:editText={['address-prompt']} class="display-l bold">{content['address-prompt']}</h2>
	<article>
		<button class="button" on:click={() => selectAddress()}>&nbsp;<span class="icon-pin-outline-20">&nbsp;</span>Enter address</button>
			<!-- TODO: find out if this can be changed - this feature is available when you click the enter address button -->
			{#if !$geoOpted$}
				<button class="button tertiary label-xl" on:click={(e) => currentLocation()}>&nbsp;<span class="icon-current-location-20">&nbsp;</span>Use current location</button>
			{/if}
	</article>
</div>

